import { Send } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";

const options = [
  ["needs_work", "Needs work", "The judging flow got in the way."],
  ["useful", "Useful", "It helped me judge the round."],
  ["excellent", "Excellent", "It made judging easier."],
];

const apiUrl = process.env.REACT_APP_BACKEND_URL;

export default function RoundFeedbackForm({ onClose, onSubmittingChange }) {
  const [comment, setComment] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [rating, setRating] = useState("");

  const updateSubmitting = (value) => {
    setIsSubmitting(value);
    onSubmittingChange(value);
  };

  const submitFeedback = async (event) => {
    event.preventDefault();
    if (!rating) return;
    updateSubmitting(true);
    try {
      const response = await fetch(`${apiUrl}/api/feedback`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ rating, comment }),
      });
      const body = await response.json();
      if (!response.ok) throw new Error(body.detail || "Feedback could not be sent.");
      toast.success("Thanks — your feedback helps shape PFJudgePro.");
      setComment("");
      setRating("");
      onClose();
    } catch (error) {
      toast.error(error.message);
    } finally {
      updateSubmitting(false);
    }
  };

  return (
    <form onSubmit={submitFeedback} data-testid="round-feedback-form">
      <div className="feedback-rating-options" data-testid="round-feedback-rating-options">
        {options.map(([id, label, description]) => (
          <button
            aria-pressed={rating === id}
            className={rating === id ? "feedback-rating-button active" : "feedback-rating-button"}
            key={id}
            onClick={() => setRating(id)}
            type="button"
            data-testid={`round-feedback-rating-${id}`}
          >
            <strong>{label}</strong>
            <span>{description}</span>
          </button>
        ))}
      </div>
      <label htmlFor="round-feedback-comment">What should improve next?</label>
      <textarea
        id="round-feedback-comment"
        maxLength={500}
        onChange={(event) => setComment(event.target.value)}
        placeholder="Optional — a few words are enough."
        value={comment}
        data-testid="round-feedback-comment-input"
      />
      <div className="feedback-modal-actions">
        <button
          className="secondary-action"
          onClick={onClose}
          type="button"
          disabled={isSubmitting}
          data-testid="round-feedback-skip-button"
        >
          Skip for now
        </button>
        <button
          className="primary-action"
          disabled={!rating || isSubmitting}
          data-testid="round-feedback-submit-button"
        >
          <Send size={16} />
          {isSubmitting ? "Sending" : "Send feedback"}
        </button>
      </div>
    </form>
  );
}